/**
*
*/
export enum SimulationTopologiesGraphType {
    PUE = "PUE",
    DCIE = "DCIE",
    CLIMATE = "CLIMATE"
}